import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useHybridAuth } from './useHybridAuth';
import { driverApi } from '../services/driverApi';

/**
 * Take an outside call on offer for this driver
 * (PUT /dispatch-offers/:id/accept with their own driver id). The call and
 * the lists are refetched either way: on success it has moved from the
 * offers to their own calls, and on a refusal someone else may have taken it.
 */
export const useAcceptOutsideCall = () => {
  const { getAccessTokenSilently } = useHybridAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      callId,
      driverId,
    }: {
      callId: string;
      driverId: string;
    }) => {
      driverApi.setAuthToken(await getAccessTokenSilently());
      return driverApi.acceptOutsideCall(callId, driverId);
    },
    onSettled: (_data, _error, { callId }) => {
      queryClient.invalidateQueries({ queryKey: ['driver-call', callId] });
      queryClient.invalidateQueries({ queryKey: ['mobile-calls'] });
    },
  });
};
